export const utilitySetupsRoutes = {
  /** The company's setups, of one utility type when it's named (LB-6182). */
  companySetups: companyId => "/companies/".concat(companyId, "/utility-setups"),
  /** The setup a property utility follows, and the setup it moves to when that's scheduled (LB-6182, LB-6183). */
  link: propertyUtilityId => "/propertyutility/".concat(propertyUtilityId, "/utility-setup"),
  /** "Make its own setup": a new setup with the utility's own values, which it then follows (LB-6182). */
  fork: propertyUtilityId => "/propertyutility/".concat(propertyUtilityId, "/utility-setup/fork"),
  /** The utility's move to another setup that waits for the next billing month (LB-6183). */
  pendingLink: propertyUtilityId => "/propertyutility/".concat(propertyUtilityId, "/utility-setup/pending"),
  /** One setup: changed as a whole, or previewed (LB-6183). */
  setup: setupId => "/utility-setups/".concat(setupId),
  /** The setup's edit that waits for the next billing month (LB-6183). */
  pendingEdit: setupId => "/utility-setups/".concat(setupId, "/pending")
};